import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useId, useRef, useState, } from "react";
import { cx } from "../lib/cx.js";
export function Menu({ trigger, items, align = "end", label, }) {
    const [open, setOpen] = useState(false);
    const wrapRef = useRef(null);
    const menuId = useId();
    useEffect(() => {
        if (!open)
            return;
        const onDoc = (e) => {
            if (!wrapRef.current?.contains(e.target))
                setOpen(false);
        };
        const onKey = (e) => {
            if (e.key === "Escape")
                setOpen(false);
        };
        document.addEventListener("mousedown", onDoc);
        document.addEventListener("keydown", onKey);
        return () => {
            document.removeEventListener("mousedown", onDoc);
            document.removeEventListener("keydown", onKey);
        };
    }, [open]);
    return (_jsxs("div", { className: "evolua-menu", ref: wrapRef, children: [_jsx("button", { type: "button", className: "evolua-menu__trigger", "aria-haspopup": "menu", "aria-expanded": open, "aria-controls": menuId, "aria-label": label, onClick: () => setOpen((v) => !v), children: trigger }), open ? (_jsx("ul", { id: menuId, role: "menu", className: cx("evolua-menu__list", align === "end" && "evolua-menu__list--end"), children: items.map((item) => (_jsx("li", { role: "none", children: item.href ? (_jsx("a", { href: item.href, role: "menuitem", className: cx("evolua-menu__item", item.danger && "evolua-menu__item--danger"), onClick: () => setOpen(false), children: item.label })) : (_jsx("button", { type: "button", role: "menuitem", disabled: item.disabled, className: cx("evolua-menu__item", item.danger && "evolua-menu__item--danger"), onClick: () => {
                            item.onSelect?.();
                            setOpen(false);
                        }, children: item.label })) }, item.id))) })) : null] }));
}
export function IconButton({ label, children, className, ...rest }) {
    return (_jsx("button", { type: "button", className: cx("evolua-icon-btn", className), "aria-label": label, ...rest, children: children }));
}
//# sourceMappingURL=Menu.js.map